import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import SignaturePad from './SignaturePad/index';
import { createStyles, withStyles, Typography, Button } from '@material-ui/core';
import cx from 'classnames';
var DEFAULT_WIDTH = 400;
var DEFAULT_HEIGHT = 200;

var styles = function styles(theme) {
  return createStyles({
    root: {
      display: 'inline-flex',
      flexDirection: 'column',
      userSelect: 'none',
      alignItems: 'center'
    },
    filled: _objectSpread({}, theme.overrides.MuiFilledInput['root'], {
      padding: 1,
      '&:hover:focus-within, &:focus-within': {
        border: '2px solid #289fcb',
        padding: 0
      },
      '&$disabled': {
        backgroundColor: '#eee',
        opacity: 1
      },
      '&:hover': {
        '&$disabled': {
          backgroundColor: '#eee',
          opacity: 1
        }
      },
      '&$disabled&': {
        '@media (hover: none)': {
          backgroundColor: '#eee',
          color: 'inherit',
          opacity: 1
        }
      }
    }),
    focused: {},
    disabled: {
      color: 'inherit',
      opacity: 0.54
    },
    role: {
      marginTop: theme.spacing(0.5)
    },
    agreement: {
      marginTop: theme.spacing(0.5)
    },
    name: {
      marginTop: theme.spacing(0.5)
    }
  });
};

var createXmlFromImage = function createXmlFromImage(imageBytes, _ref) {
  var recipientRole = _ref.recipientRole,
      recipientName = _ref.recipientName,
      agreement = _ref.agreement;
  if (!imageBytes) return null;
  var recipientNameXml = '<name/>';
  if (recipientName) recipientNameXml = "<name>".concat(encodeURIComponent(recipientName), "</name>");
  var recipientRoleXml = '<role/>';
  if (recipientRole) recipientRoleXml = "<role>".concat(encodeURIComponent(recipientRole), "</role>");
  var agreementXml = '<agreement/>';
  if (agreement) agreementXml = "<agreement>".concat(encodeURIComponent(agreement), "</agreement>");
  return "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n  <signature>\n    <version>1.0</version>\n    <name/>\n    <timestamp>".concat(new Date().toISOString(), "</timestamp>\n    <gps/>\n    <device/>\n    <ip/>\n    <presentation>\n      ").concat(recipientNameXml, "\n      ").concat(recipientRoleXml, "\n      ").concat(agreementXml, "\n    </presentation>\n    <img>").concat(imageBytes, "</img>\n  </signature>");
};

var getImageFromXml = function getImageFromXml(xmlStr) {
  if (!xmlStr) return null;
  var parser = new DOMParser();
  var xmlDoc = parser.parseFromString(xmlStr, 'text/xml');
  var imgBytes = null;

  if (xmlDoc) {
    try {
      imgBytes = xmlDoc.getElementsByTagName('img')[0].childNodes[0].nodeValue;
    } catch (e) {}
  }

  return imgBytes;
};

var useImage = function useImage(value, onChange, valueType, profile, triggerSignatureChangeOnly) {
  var agreement = profile.agreement,
      recipientRole = profile.recipientRole,
      recipientName = profile.recipientName;
  var initialImage = null;
  if (valueType === 'image') initialImage = value;else if (valueType === 'xml') initialImage = getImageFromXml(value);else if (valueType === 'xmlBase64') initialImage = getImageFromXml(atob(value));

  var _React$useState = React.useState(initialImage),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      image = _React$useState2[0],
      setImage = _React$useState2[1];

  var refreshValue = function refreshValue() {
    return onChangeImage(image);
  };

  React.useEffect(function () {
    if (triggerSignatureChangeOnly) return;
    refreshValue();
  }, [valueType, decodeURIComponent(agreement), decodeURIComponent(recipientRole), decodeURIComponent(recipientName)]);
  React.useEffect(function () {
    setImage(function (image) {
      if (image === initialImage) return image;
      return initialImage;
    });
  }, [initialImage]);

  var onChangeImage = function onChangeImage(newImage) {
    if (onChange) {
      if (valueType === 'image') {
        onChange(newImage);
      } else if (valueType === 'xml') {
        onChange(createXmlFromImage(newImage, profile));
      } else if (valueType === 'xmlBase64') {
        var signatureXml = createXmlFromImage(newImage, profile);
        onChange(signatureXml ? btoa(signatureXml) : signatureXml);
      }
    }

    setImage(newImage);
  };

  return [image, onChangeImage];
};
/**@param {import('./types').SignatureProps & import('@material-ui/core').WithStyles<typeof styles>} props */


var Signature = function Signature(_ref2) {
  var classes = _ref2.classes,
      disabled = _ref2.disabled,
      variant = _ref2.variant,
      agreement = _ref2.agreement,
      recipientRole = _ref2.recipientRole,
      recipientName = _ref2.recipientName,
      hideClear = _ref2.hideClear,
      valueType = _ref2.valueType,
      value = _ref2.value,
      onChange = _ref2.onChange,
      enableOnFocus = _ref2.enableOnFocus,
      triggerSignatureChangeOnly = _ref2.triggerSignatureChangeOnly,
      clearButtonContent = _ref2.clearButtonContent,
      rest = _objectWithoutProperties(_ref2, ["classes", "disabled", "variant", "agreement", "recipientRole", "recipientName", "hideClear", "valueType", "value", "onChange", "enableOnFocus", "triggerSignatureChangeOnly", "clearButtonContent"]);

  var _useImage = useImage(value, onChange, valueType, {
    agreement: agreement,
    recipientRole: recipientRole,
    recipientName: recipientName
  }, triggerSignatureChangeOnly),
      _useImage2 = _slicedToArray(_useImage, 2),
      image = _useImage2[0],
      setImage = _useImage2[1];

  var signed = React.createRef();
  return React.createElement("div", {
    className: cx(classes.root, classes[variant], disabled ? classes.disabled : {})
  }, recipientRole && React.createElement(Typography, {
    className: disabled ? cx(classes.role, classes.disabled) : classes.role
  }, recipientRole), React.createElement(SignaturePad, Object.assign({
    ref: signed,
    defaultValue: image,
    onChange: setImage,
    variant: variant,
    disabled: disabled,
    enableOnFocus: enableOnFocus
  }, rest)), agreement && React.createElement(Typography, {
    className: disabled ? cx(classes.agreement, classes.disabled) : classes.agreement
  }, agreement), recipientName && React.createElement(Typography, {
    className: disabled ? cx(classes.name, classes.disabled) : classes.name
  }, recipientName), !hideClear && React.createElement(Button, {
    onClick: function onClick() {
      return setImage(null);
    },
    disabled: disabled ? true : false
  }, clearButtonContent || 'Clear'));
};
/**@type {Partial<import('./types').SignatureProps>} */


Signature.defaultProps = {
  agreement: 'I agree with terms and conditions',
  recipientRole: 'Representative',
  recipientName: null,
  placeholder: 'Sign here...',
  hideClear: false,
  valueType: 'image',
  enableOnFocus: false,
  width: DEFAULT_WIDTH,
  height: DEFAULT_HEIGHT,
  triggerSignatureChangeOnly: false,
  clearButtonContent: 'Clear'
};
export default withStyles(styles, {
  name: 'ECSignature'
})(Signature);